import faviconURL from '../../../../assets/image/favicon.png';
import qaFaviconURL from '../../../../assets/image/panalytQA.png';

import { Environment, Environments } from '../../environment/environments';

export const initFavicon = (environment: Environment) => {
  const favicon = document.getElementById('favicon') as HTMLLinkElement;
  const env = environment;

  if (favicon) {
    if (env.name === Environments.PANACLOUD_QA) {
      favicon.href = qaFaviconURL;
    } else {
      favicon.href = faviconURL;
    }
  }
};
